import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function FeaturedSections() {
  return <div className="w-full" data-id="element-24">
      {/* Featured Grid */}
      <section className="grid grid-cols-1 md:grid-cols-2 overflow-hidden" data-id="element-25">
        <motion.div initial={{
        x: -50,
        opacity: 0
      }} whileInView={{
        x: 0,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-[#FDFCF0] text-[#2C2C2C] p-12 md:p-32 flex flex-col justify-center min-h-[600px]" data-id="element-26">
          <span className="section-overline" data-id="element-27">The Collection</span>
          <h2 className="mb-8" data-id="element-28">The Experience</h2>
          <p className="text-[#2C2C2C]/70" data-id="element-29">
            Immerse yourself in the world of Cork Dorx. From private cellar
            tours to sensory tasting journeys, we curate every detail to ensure
            your visit is nothing short of extraordinary.
          </p>
          <button className="border border-[#4A0E0E] text-[#4A0E0E] px-10 py-4 w-fit hover:bg-[#4A0E0E] hover:text-white rounded-full" data-id="element-30">
            Explore More
          </button>
        </motion.div>
        <div className="h-[600px] md:h-auto bg-cover bg-center" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/o3BaCHmJCEKZLanYpAWrmk/pexels-jep-gambardella-5086626.jpg)'
      }} data-id="element-31" />
      </section>

      <section className="grid grid-cols-1 md:grid-cols-2" data-id="element-32">
        <div className="h-[600px] md:h-auto bg-cover bg-center order-2 md:order-1" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/eBNcDPLQZGwXr4seeURyi4/pexels-freestockpro-9397571.jpg)'
      }} data-id="element-33" />
        <motion.div initial={{
        x: 50,
        opacity: 0
      }} whileInView={{
        x: 0,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white text-[#2C2C2C] p-12 md:p-32 flex flex-col justify-center order-1 md:order-2 min-h-[600px]" data-id="element-34">
          <span className="section-overline" data-id="element-35">Community & Culture</span>
          <h2 className="mb-8" data-id="element-36">Interactive and Engaging Atmosphere</h2>
          <p className="text-[#2C2C2C]/70" data-id="element-37">
            Discover a vibrant space where wine culture comes alive. Our events
            and workshops are designed to be hands-on, social, and deeply
            educational, fostering a community of passionate enthusiasts.
          </p>
          <button className="border border-[#4A0E0E] text-[#4A0E0E] px-10 py-4 w-fit hover:bg-[#4A0E0E] hover:text-white rounded-full" data-id="element-38">
            Join the Community
          </button>
        </motion.div>
      </section>

      {/* Partnerships Section */}
      <section className="max-w-7xl mx-auto px-6 py-32 text-center" data-id="element-39">
        <span className="section-overline" data-id="element-40">Collaborations</span>
        <h2 className="text-[#4A0E0E] mb-16" data-id="element-41">Our Partnerships</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-8" data-id="element-42">
          {[{
          title: 'Wineries',
          desc: 'Prestigious Estates',
          img: 'https://cdn.magicpatterns.com/uploads/2nsRKWkqPRdLsMSFkk8CnB/pexels-polina-kovaleva-7270303.jpg',
          href: '/partnerships/wineries'
        }, {
          title: 'Restaurants',
          desc: 'Culinary Partners',
          img: 'https://cdn.magicpatterns.com/uploads/c5frN6f2N8bEQ9Eyd3mP9C/pexels-shvetsa-11368648.jpg',
          href: '/partnerships/restaurants'
        }, {
          title: 'Social Clubs',
          desc: 'Private Organizations',
          img: 'https://cdn.magicpatterns.com/uploads/iwo8PMMsuiXkkx6d5SoJB5/pexels-joseismaelespinola-19542527.jpg',
          href: '/partnerships/social-clubs'
        }, {
          title: 'Event Venues',
          desc: 'Distinctive Spaces',
          img: 'https://cdn.magicpatterns.com/uploads/vjL8XmfAru8DqVvkiBNSGa/pexels-araujo-5004027.jpg',
          href: '/partnerships/event-venues'
        }, {
          title: 'Philanthropy',
          desc: 'Nonprofit Initiatives',
          img: 'https://cdn.magicpatterns.com/uploads/24VNA1D7kt6uyMyfcaCRF6/pexels-hannah-barata-776560167-27788076.jpg',
          href: '/partnerships/philanthropy'
        }].map((partner, idx) => <Link to={partner.href} key={idx} className="group cursor-pointer" data-id="element-43">
              <div className="overflow-hidden mb-6 aspect-[4/5] rounded-2xl" data-id="element-44">
                <img src={partner.img} alt={partner.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-45" />
              </div>
              <h3 className="text-lg font-serif text-[#2C2C2C] group-hover:text-[#D4AF37] transition-colors" data-id="element-46">
                {partner.title}
              </h3>
              <p className="text-[10px] uppercase tracking-[0.2em] text-[#2C2C2C]/50 mt-2" data-id="element-47">
                {partner.desc}
              </p>
            </Link>)}
        </div>
      </section>
    </div>;
}